import React from 'react';

import SmartFilterIndicator from '../../smart-filter-indicator';
import colors from '../../../../../theme';
import { StatusIndicatorContainer } from './status-indicator.style';
import loadShape from '../../../../../shapes/load';

/**
 * Shapes that are displayed on a load in a table
 * @param {object} props - Object containing the props for this component
 * @param {string} props.data - data on a single load
 * @return {element}
 */
const StatusIndicator = ({ data }) => (
  <StatusIndicatorContainer>
    {data?.problems?.length > 0 && (
      <SmartFilterIndicator
        type="octagon"
        color={colors.palette.red[100]}
        size="12"
      />
    )}
    {data?.isLateLoad && (
      <SmartFilterIndicator
        type="diamond"
        color={colors.palette.orange[100]}
        size="12"
      />
    )}
  </StatusIndicatorContainer>
);

StatusIndicator.propTypes = {
  data: loadShape,
};

StatusIndicator.defaultProps = {
  data: null,
};

export default StatusIndicator;
